import React  from 'react';
import DatePicker from 'react-bootstrap-date-picker';
import PropTypes from 'prop-types';

export const DatePickerComp = (props) => {
        return (
            <div className="col-sm-4">
                <label>{props.label}</label>
                <DatePicker id={props.id} value={props.datum} onChange={props.changeDP} />
            </div>
        )
}

DatePickerComp.PropTypes = {
    id: PropTypes.number,
    datum: PropTypes.string,
    changeDP: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/components/DatePickerComp.js